/**
 * Check if a user is allowed to perform step-up authentication
 *
 * @param {Object} user User object from Auth0
 * @returns {boolean} Whether the user is allowed to perform step-up authentication
 */
export const isStepUpAllowed = (user) => {
  if (!user) return false;

  const namespace = process.env.REACT_APP_USER_CLAIMS_NAMESPACE || 'http://app.livingsecurity.com/claims';

  return !!user[`${namespace}/step_up_allowed`];
};

/**
 * Check if a user has already stepped up their authentication
 *
 * @param {Object} user User object from Auth0
 * @returns {boolean} Whether the user has stepped up their authentication
 */
export const isSteppedUp = (user) => {
  if (!user) return false;

  const namespace = process.env.REACT_APP_USER_CLAIMS_NAMESPACE || 'http://app.livingsecurity.com/claims';
  const groups = user[`${namespace}/groups`] || [];

  return groups.includes('LS_ADMIN');
}

